import { USE_AUTH0_KEY } from './constants';
import { getRegionFromHostname } from './region.web';

/**
 * Check if Auth0 authentication is enabled.
 * The localStorage flag takes precedence - if explicitly set to 'false',
 * legacy auth is used regardless of region.
 * Otherwise, EU region defaults to Auth0, US region defaults to legacy.
 */
export const isAuth0Enabled = (): boolean => {
  const flag = localStorage.getItem(USE_AUTH0_KEY);

  // Explicit false always uses legacy auth (for local dev/testing)
  if (flag === 'false') {
    return false;
  }

  // Explicit true always uses Auth0
  if (flag === 'true') {
    return true;
  }

  // EU region always uses Auth0, US region defaults to legacy
  return getRegionFromHostname() === 'EU';
};

/**
 * Enable Auth0 authentication
 */
export const enableAuth0 = (): void => {
  localStorage.setItem(USE_AUTH0_KEY, 'true');
};

/**
 * Disable Auth0 and revert to legacy auth
 */
export const disableAuth0 = (): void => {
  localStorage.removeItem(USE_AUTH0_KEY);
};
